import { useState, useEffect } from 'react';

const ReportErrorBanner = ({ errors }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    if (errors && errors.length > 0) {
      setIsVisible(true);
    }
  }, [errors]);

  if (!errors || errors.length === 0 || !isVisible) return null;

  return (
    <div style={{
      backgroundColor: '#fff5f5', 
      borderLeft: '5px solid #e53e3e', 
      borderRadius: '6px',
      padding: '14px 20px',
      marginBottom: '20px',
      position: 'relative',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      border: '1px solid #feb2b2', // Soft red outline
    }}>
      {/* Dismiss Button */}
      <button 
        onClick={() => setIsVisible(false)}
        style={{
          position: 'absolute',
          top: '10px',
          right: '12px',
          background: 'none',
          border: 'none',
          fontSize: '20px',
          cursor: 'pointer',
          color: '#c53030', // Dark red
          fontWeight: 'bold',
          opacity: 0.6
        }}
      >
        ×
      </button>

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginRight: '30px' }}>
        <div style={{ display: 'flex', alignItems: 'center', color: '#c53030' }}>
          <span style={{ fontSize: '22px', marginRight: '12px' }}>🚫</span>
          <strong style={{ fontSize: '1rem', fontWeight: '700' }}>
            Critical: {errors.length} month(s) failed to load. Please try again.
          </strong>
        </div>
        <button 
          onClick={() => setIsOpen(!isOpen)}
          style={{
            background: '#fed7d7',
            border: '1px solid #feb2b2',
            color: '#9b2c2c',
            borderRadius: '4px',
            padding: '4px 10px',
            cursor: 'pointer',
            fontSize: '0.8rem',
            fontWeight: '600',
            height: '30px',          
            lineHeight: '30px',
            display: 'inline-flex',
            alignItems: 'center',
          }}
        >
          {isOpen ? 'Hide Issues' : 'View Issues'}
        </button>
      </div>

      {isOpen && (
        <div style={{ 
            marginTop: '12px', 
            borderTop: '1px solid #feb2b2', 
            paddingTop: '10px',
            maxHeight: '200px',
            overflowY: 'auto' // Add scroll if there are 66+ errors
        }}>
          <ul style={{ margin: 0, paddingLeft: '20px', fontSize: '0.85rem', color: '#822727', lineHeight: '1.6' }}>
            {errors.map((err, idx) => <li key={idx}>{err}</li>)}
          </ul>
        </div>
      )}
    </div>
  );
};

export default ReportErrorBanner;